export function formatNumber(
  value: number,
  options: Intl.NumberFormatOptions = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  },
) {
  return value.toLocaleString('en-GB', options);
}
